import { render, staticRenderFns } from "./SmtpRelays.vue?vue&type=template&id=21bb5bc4&scoped=true"
import script from "./SmtpRelays.vue?vue&type=script&lang=js"
export * from "./SmtpRelays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bb5bc4",
  null
  
)

export default component.exports